import $api from "../http";
import {
  EmailTemplateLanguageType,
  EmailTemplateSubjectEnum,
  ICreateOrUpdateEmailTemplate,
  IEmailTemplate,
  IEmailTemplateForTable,
  IEmailTemplateSubject,
  IEmailTemplateVersion,
} from "../models/EmailTemplate";

class EmailTemplateServiceClass {
  async getEmailTemplateVersionByLanguage(
    emailTemplateId: string,
    language: EmailTemplateLanguageType
  ) {
    return $api.get<IEmailTemplateVersion>(
      `api/email-template/version/${emailTemplateId}?language=${language}`
    );
  }

  async getEmailTemplateSubjects() {
    return $api.get<IEmailTemplateSubject[]>(`api/email-template/subjects`);
  }

  async getEmailTemplateById(id: string) {
    return $api.get<IEmailTemplate>(`api/email-template/${id}`);
  }

  async getEmailTemplateConstants() {
    return $api.get<string[]>(`api/email-template/constants`);
  }

  async createOrUpdateEmailTemplate(model: ICreateOrUpdateEmailTemplate) {
    return $api.post<{}>(`api/email-template`, model);
  }

  async getAllEmailTemplates(currentPage: number | undefined, pageSize: number | undefined) {
    let queryString = `currentPage=${currentPage}&pageSize=${pageSize}`;
    return $api.get<{ items: IEmailTemplateForTable[]; total: number }>(
      `api/email-template?${queryString}`
    );
  }

  async deleteEmailTemplate(id: string) {
    return $api.delete<{}>(`api/email-template/${id}`);
  }

  async testSendEmailTemplate(
    to: string,
    language: EmailTemplateLanguageType,
    subject: EmailTemplateSubjectEnum
  ) {
    return $api.post<boolean>(`api/email-template/test/send-${subject}-email`, {
      to,
      language,
    });
  }
}

export const EmailTemplateService = new EmailTemplateServiceClass();
